<div class="projects-page">
  <h2 class="projects-page__header h1">Projects</h2>
  <div class="projects-page__controls">
    <form [formGroup]="form" class="projects-page__filters">
      <mat-form-field appearance="fill" class="filters-form-field">
        <mat-label>Project name</mat-label>
        <mat-icon matPrefix class="me-1">folder</mat-icon>
        <input matInput [formControlName]="'title'">
      </mat-form-field>

      <div class="time-entry-input__field time-entry-input__field--tags">
        <select-list #selectListClients [optionList]="optionsFromClients" [multiple]="true" [searchBar]="true" label="Clients" icon="business" (selectedOptionsChanged)="form.get('clients')?.setValue($event)" />
      </div>

      <div class="time-entry-input__field time-entry-input__field--tags">
        <select-list #selectListMembers [optionList]="optionsFromMembers" [multiple]="true" [searchBar]="true" label="Members" icon="group" (selectedOptionsChanged)="form.get('members')?.setValue($event)" />
      </div>

      <div class="d-flex align-items-center gap-3 ms-2">
        <mat-checkbox formControlName="active" class="small">
          Active projects
        </mat-checkbox>
        <mat-checkbox formControlName="archived" class="small">
          Archived projects
        </mat-checkbox>
      </div>
    </form>
    @if (isManager) {
    <button (click)="openCreateProjectDialog('0ms','0ms')" mat-flat-button>Create project</button>
    }
  </div>

  @if (isManager) {
  <button mat-flat-button (click)="openItemAnnihilatorDialog('0ms', '0ms')">Delete projects</button>
  }

  <div class="projects-page__table-container mat-elevation-z8 mat-table-responsive">
    <table mat-table [dataSource]="dataSource" matSort class="projects-page__table">
      <!-- Project Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header"> Project </th>
        <td mat-cell *matCellDef="let project" [ngStyle]="{'color': project.color}"> {{project.name}} </td>
      </ng-container>

      <!-- Client Column -->
      <ng-container matColumnDef="client">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header"> Client </th>
        <td mat-cell *matCellDef="let project"> {{project.client.name}} </td>
      </ng-container>

      <!-- Timeframe Column -->
      <ng-container matColumnDef="timeframe">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header"> Timeframe </th>
        <td mat-cell *matCellDef="let project" [ngClass]="{'inactive-timeframe': !project.active}">
          {{project.created.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}}
          <span *ngIf="!project.active"> (completed)</span>
        </td>
      </ng-container>

      <!-- Time Status Column -->
      <ng-container matColumnDef="timeStatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header"> Time Status </th>
        <td mat-cell *matCellDef="let project"> {{formatTimeSpent(project.time_spent)}} h </td>
      </ng-container>

      <!-- Team Column -->
      <!-- TODO: Add again this column when teams are implemented -->
      <!-- <ng-container matColumnDef="team"> -->
      <!--   <th mat-header-cell *matHeaderCellDef class="table-header"> Team </th> -->
      <!--   <td mat-cell *matCellDef="let project"> Example team </td> -->
      <!-- </ng-container> -->

      <ng-container matColumnDef="update">
        <th mat-header-cell *matHeaderCellDef class="table-header"></th>
        <td mat-cell *matCellDef="let project">
          @if (isManager) {
          <button (click)="openUpdateProjectDialog(project.id,'0ms','0ms')" mat-flat-button>Update</button>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="delete">
        <th mat-header-cell *matHeaderCellDef class="table-header"></th>
        <td mat-cell *matCellDef="let project">
          @if (isManager) {
          <button mat-flat-button (click)="deleteProject(project)">Delete</button>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

  </div>
